import {post,instance,get} from '@/api/index'


export function loginUser(data) {
    return post('/app/user/login', data)
}

export function addUser(data) {
    return post('/app/user/save', data)
}

export function updateUser(data) {
    return post('/app/user/update', data)
}

export function deleteUser(data) {
    return post('/app/user/delete', data)
}

export function userList(data) {
    return get('/app/user/list', data)
}

export function getUserMenu(data) {
    return get('/app/user/getUserMenu', data)
}

export function getImageVerifica(params) {
  return instance.get('/app/user/image', {
    params,
    responseType: 'arraybuffer' // ⭐ 强烈推荐
  })
}

export function updatePassword(data) {
    return post('/app/user/updatePassword', data)
}

/**
 * 获取个人用户详细信息（含统计数据与登录日志）
 * @param {number|string} userId
 */
export function getUserProfile(userId) {
    return get('/app/user/profile', { userId })
}

/**
 * 获取当前用户的数据统计
 */
export function getUserStat() {
    return get('/app/user/stat')
}

/**
 * 获取登录日志列表
 * @param {object} params - { page, limit }
 */
export function getLoginLogs(params) {
    return get('/app/user/loginLog', params)
}
